/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  ChemicalConstraintCoefficient,
  ChemicalElement,
} from "src/store/api/generatedApi";

export const chemicalExpressionFromConstraintCoefficients = (
  name: string | null | undefined,
  coefficients: ChemicalConstraintCoefficient[],
  elements: Record<number, ChemicalElement>
) => {
  if (name !== undefined && name !== null) {
    return name;
  } else {
    return coefficients
      .map((coefficient) =>
        coefficient.coefficient == 1
          ? elements[coefficient.chemical_element.id]!.symbol
          : `${coefficient.coefficient}${
              elements[coefficient.chemical_element.id]!.symbol
            }`
      )
      .join(" + ");
  }
};
